import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSocket } from "../../../utils/constants";
import { useCasinoStyles } from "../useCasinoStyles";

const labels = ["Dragon", "Tiger", "Lion"];
const value = (object, keys, fallback = "—") => {
  for (const key of keys) {
    if (object && object[key] !== undefined && object[key] !== null && object[key] !== "") return object[key];
  }
  return fallback;
};

function OddsCell({ odd }) {
  const number = typeof odd === "object" ? value(odd, ["odd", "rate", "value", "price"]) : odd;
  return <div className="dtl-odds-cell"><strong>{number}</strong><small>0</small></div>;
}

export default function DTL20() {
  const dispatch = useDispatch();
  const odds = useSelector((state) => state.gameData.dragonTiger20Odds || {});
  const [isResultModalOpen, setIsResultModalOpen] = useState(false);
  const [isRulesOpen, setIsRulesOpen] = useState(false);
  const [roundProgress, setRoundProgress] = useState(100);
  useCasinoStyles();

  useEffect(() => {
    createSocket("casino", dispatch, "dragonTiger20");
  }, [dispatch]);

  useEffect(() => {
    const duration = 10_000;
    const startedAt = performance.now();
    let animationFrame;

    const updateProgress = (now) => {
      const elapsedPercent = Math.min(((now - startedAt) / duration) * 100, 100);
      const progress = 100 - elapsedPercent;
      setRoundProgress(progress);
      if (progress > 0) animationFrame = requestAnimationFrame(updateProgress);
    };

    animationFrame = requestAnimationFrame(updateProgress);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  const round = value(odds, ["roundId", "roundID", "round", "marketId"], "Waiting for round");
  const cards = value(odds, ["cards", "cardDetails"], []);
  const cardFor = (name, index) => {
    if (Array.isArray(cards)) return cards[index];
    return value(odds, [`${name.toLowerCase()}Card`, `${name.toLowerCase()}Cards`, name], "—");
  };
  const mainOdds = Array.isArray(odds.mainOdds) ? odds.mainOdds : [];
  const rows = labels.map((name, index) => ({
    name,
    card: cardFor(name, index),
    values: mainOdds[index]?.values || mainOdds[index] || [],
  }));

  return (
   <>
 <div data-v-61537a09="" className="detail-page-container">
  <div className="center-main-container">
    <div className="center-content">
      <div className="casino-container">
        <div className="casino-table vcasino vdtl">
          <div className="progress mobile-timer">
            <div
              className="progress-bar bg-success"
              role="progressbar"
              aria-label="Round timer"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={Math.round(roundProgress)}
              style={{ width: `${roundProgress}%` }}
            />
          </div>{" "}
          <div className="casino-video">
            <div className="casino-video-title">
              <span className="casino-name">V-20-20 D T L</span>{" "}
              <div className="casino-video-rid">Round ID: 319260921232105</div>
            </div>{" "}
            <div className="video-box-container">
              <div className="video-box" />
            </div>{" "}
            <div className="vcasino-cards">
              <div className="player-card playera-card">
                {/**/} <div className="w-100 playera mb-2">DRAGON</div>{" "}
                <span data-v-79776e43="">
                  <img
                    data-v-79776e43=""
                    src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/1.png"
                  />
                </span>
              </div>{" "}
              <div className="player-card playera-card">
                {/**/} <div className="w-100 tie mb-2">TIGER</div>{" "}
                <span data-v-79776e43="">
                  <img
                    data-v-79776e43=""
                    src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/1.png"
                  />
                </span>
              </div>{" "}
              <div className="player-card playera-card">
                {/**/} <div className="w-100 playerb mb-2">LION</div>{" "}
                <span data-v-79776e43="">
                  <img
                    data-v-79776e43=""
                    src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/1.png"
                  />
                </span>
              </div>
            </div>{" "}
            <div className="casino-video-right-icons">
              <div title="Home" className="casino-video-home-icon">
                <a
                  href="/admin/vcasino/list"
                  className=""
                  style={{ color: "var(--text-highlight)" }}
                >
                  <i className="fas fa-home" />
                </a>
              </div>{" "}
              <div
                title="Rules"
                className="casino-video-rules-icon"
                role="button"
                tabIndex={0}
                aria-label="Open game rules"
                onClick={() => setIsRulesOpen(true)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    setIsRulesOpen(true);
                  }
                }}
              >
                <i className="fas fa-info-circle" />
              </div>
            </div>{" "}
            <div>
              {/**/} {/**/}
            </div>
            <CasinoRules isOpen={isRulesOpen} onClose={() => setIsRulesOpen(false)} />
          </div>{" "}
          <div className="casino-detail">
            <div className="main-odds">
              <div className="main-odds-left">
                <div className="vdtl-odds-heading">Main Odds</div>{" "}
                <div className="v-odd-row">
                  <div className="v-odd-box">
                    <b>&nbsp;</b>
                  </div>{" "}
                  <div className="v-odd-box">
                    <b>Winner</b>{" "}
                    <div className="d-inline-block ml-2 float-right">
                      <i
                        data-toggle="collapse"
                        data-target="#demo0"
                        aria-expanded="false"
                        className="fas fa-info-circle collapsed"
                      />{" "}
                      <div id="demo0" className="icon-range collapse">
                        R:<span>25</span>-<span>25K</span>
                      </div>
                    </div>
                  </div>{" "}
                  <div className="v-odd-box">
                    <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/spade.png" />{" "}
                    <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/club.png" />{" "}
                    <div className="d-inline-block ml-2 float-right">
                      <i
                        data-toggle="collapse"
                        data-target="#demo1"
                        aria-expanded="false"
                        className="fas fa-info-circle collapsed"
                      />{" "}
                      <div id="demo1" className="icon-range collapse">
                        R:<span>25</span>-<span>15K</span>
                      </div>
                    </div>
                  </div>{" "}
                  <div className="v-odd-box">
                    <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/heart.png" />{" "}
                    <img src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/diamond.png" />{" "}
                    <div className="d-inline-block ml-2 float-right">
                      <i
                        data-toggle="collapse"
                        data-target="#demo2"
                        aria-expanded="false"
                        className="fas fa-info-circle collapsed"
                      />{" "}
                      <div id="demo2" className="icon-range collapse">
                        R:<span>25</span>-<span>15K</span>
                      </div>
                    </div>
                  </div>{" "}
                  <div className="v-odd-box">
                    <b>Odd</b>{" "}
                    <div className="d-inline-block ml-2 float-right">
                      <i
                        data-toggle="collapse"
                        data-target="#demo3"
                        aria-expanded="false"
                        className="fas fa-info-circle collapsed"
                      />{" "}
                      <div id="demo3" className="icon-range collapse">
                        R:<span>25</span>-<span>15K</span>
                      </div>
                    </div>
                  </div>{" "}
                  <div className="v-odd-box">
                    <b>Even</b>{" "}
                    <div className="d-inline-block ml-2 float-right">
                      <i
                        data-toggle="collapse"
                        data-target="#demo4"
                        aria-expanded="false"
                        className="fas fa-info-circle collapsed"
                      />{" "}
                      <div id="demo4" className="icon-range collapse">
                        R:<span>25</span>-<span>15K</span>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                <div className="v-odd-row">
                  <div className="v-odd-box">
                    <b>Dragon</b>
                  </div>{" "}
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">2.94</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">1.95</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">1.95</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">1.79</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">2.1</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                <div className="v-odd-row">
                  <div className="v-odd-box">
                    <b>Tiger</b>
                  </div>{" "}
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">2.94</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">1.95</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">1.95</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">1.79</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">2.1</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                <div className="v-odd-row">
                  <div className="v-odd-box">
                    <b>Lion</b>
                  </div>{" "}
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">2.94</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">1.95</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">1.95</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">1.79</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="v-odd-box">
                    <div className="casino-bl-box">
                      <div className="casino-bl-box-item back">
                        <span className="casino-box-odd">2.1</span>{" "}
                        <span className="book-odd book-red">0</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>{" "}
              <div className="main-odds-right">
                <div className="vdtl-odds-heading">Card Odds</div>{" "}
                <div className="w-100 mt-2 v-dragon-box">
                  <h5 className="text-center">Dragon</h5>{" "}
                  <div className="v-odd-row">
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>1</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo5"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo5" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>2</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo6"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo6" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>3</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo7"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo7" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>4</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo8"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo8" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>5</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo9"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo9" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>6</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo10"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo10" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>7</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo11"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo11" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>8</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo12"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo12" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>9</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo13"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo13" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>10</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo14"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo14" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>J</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo15"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo15" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>Q</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo16"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo16" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>K</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo17"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo17" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box-item back suspended lock-top">
                          <span className="casino-box-odd">0</span>{" "}
                          <span className="book-odd book-red">0</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                <div className="w-100 mt-2 v-tiger-box">
                  <h5 className="text-center">Tiger</h5>{" "}
                  <div className="v-odd-row">
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>1</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo23"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo23" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>2</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo24"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo24" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>3</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo25"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo25" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>4</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo26"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo26" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>5</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo27"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo27" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>6</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo28"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo28" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>7</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo29"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo29" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>8</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo30"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo30" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>9</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo31"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo31" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>10</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo32"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo32" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>J</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo33"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo33" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>Q</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo34"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo34" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>K</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo35"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo35" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                <div className="w-100 mt-2 v-lion-box">
                  <h5 className="text-center">Lion</h5>{" "}
                  <div className="v-odd-row">
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>1</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo41"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo41" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>2</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo42"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo42" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>3</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo43"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo43" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>4</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo44"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo44" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>5</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo45"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo45" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>6</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo46"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo46" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>7</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo47"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo47" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>8</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo48"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo48" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>9</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo49"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo49" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>10</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo50"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo50" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>J</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo51"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo51" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>Q</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo52"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo52" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="v-odd-box">
                      <div className="casino-bl-box">
                        <div className="w-100-text-center">
                          <b>K</b>{" "}
                          <div className="d-inline-block ml-2 float-right">
                            <i
                              data-toggle="collapse"
                              data-target="#demo53"
                              aria-expanded="false"
                              className="fas fa-info-circle collapsed"
                            />{" "}
                            <div id="demo53" className="icon-range collapse">
                              R:<span>25</span>-<span>10K</span>
                            </div>
                          </div>
                        </div>{" "}
                        <div className="casino-bl-box">
                          <div className="casino-bl-box-item back suspended lock-top">
                            <span className="casino-box-odd">0</span>{" "}
                            <span className="book-odd book-red">0</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>{" "}
            {/**/}{" "}
            <div
              className="casino-video-last-results"
              role="button"
              tabIndex={0}
              aria-label="Open last DTL result"
              onClick={() => setIsResultModalOpen(true)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  setIsResultModalOpen(true);
                }
              }}
            >
              <span className="resultc">
                {/**/} {/**/} L {/**/}
              </span>
              <span className="resultc">
                {/**/} {/**/} L {/**/}
              </span>
              <span className="resultc">
                {/**/} {/**/} L {/**/}
              </span>
              <span className="resultb">
                {/**/} T {/**/} {/**/}
              </span>
              <span className="resulta">
                D {/**/} {/**/} {/**/}
              </span>
              <span className="resulta">
                D {/**/} {/**/} {/**/}
              </span>
              <span className="resultb">
                {/**/} T {/**/} {/**/}
              </span>
              <span className="resultb">
                {/**/} T {/**/} {/**/}
              </span>
              <span className="resultc">
                {/**/} {/**/} L {/**/}
              </span>
              <span className="resulta">
                D {/**/} {/**/} {/**/}
              </span>{" "}
              {/**/} {/**/}
            </div>
          </div>
        </div>
      </div>
    </div>{" "}
    <div className="right-sidebar sticky">
      <div className="right-sidebar sticky">
        <div data-simplebar-auto-hide="true" data-simplebar="init">
          <div className="simplebar-wrapper" style={{ margin: 0 }}>
            <div className="simplebar-height-auto-observer-wrapper">
              <div className="simplebar-height-auto-observer" />
            </div>{" "}
            <div className="simplebar-mask">
              <div className="simplebar-offset" style={{ right: 0, bottom: 0 }}>
                <div
                  className="simplebar-content-wrapper"
                  tabIndex={0}
                  role="region"
                  aria-label="scrollable content"
                  style={{ height: "auto", overflow: "hidden" }}
                >
                  <div className="simplebar-content" style={{ padding: 0 }}>
                    <div className="casino-right-sidebar">
                      <div className="card m-b-10 my-bet">
                        <div className="card-header">
                          <h6 className="card-title float-left">My Bets</h6>{" "}
                          <a
                            href="javascript:void(0)"
                            className="btn btn-back float-right"
                          >
                            View More
                          </a>
                        </div>{" "}
                        <div className="card-body1">
                          <div className="tab-content">
                            <div id="matched-bet" className="tab-pane active">
                              <div className="table-responsive1">
                                <table className="table coupon-table table-striped mb-0">
                                  <thead>
                                    <tr>
                                      <th style={{ minWidth: 90 }}>UserName</th>{" "}
                                      <th
                                        className="text-right"
                                        style={{ minWidth: 50 }}
                                      >
                                        Rate
                                      </th>{" "}
                                      <th
                                        className="text-right"
                                        style={{ minWidth: 70 }}
                                      >
                                        Amount
                                      </th>
                                    </tr>
                                  </thead>{" "}
                                  <tbody>
                                    <tr>
                                      <td colSpan={4} className="text-center">
                                        No records found
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>{" "}
                      {/**/}
                    </div>
                  </div>
                </div>
              </div>
            </div>{" "}
            <div
              className="simplebar-placeholder"
              style={{ width: "auto", height: 100 }}
            />
          </div>{" "}
          <div
            className="simplebar-track simplebar-horizontal"
            style={{ visibility: "hidden" }}
          >
            <div
              className="simplebar-scrollbar"
              style={{ width: 0, display: "none" }}
            />
          </div>{" "}
          <div
            className="simplebar-track simplebar-vertical"
            style={{ visibility: "hidden" }}
          >
            <div
              className="simplebar-scrollbar"
              style={{ height: 0, display: "none" }}
            />
          </div>
        </div>{" "}
        {/**/} {/**/}
      </div>
    </div>
  </div>{" "}
  {/**/}
</div>
     <CasinoResultModal
       isOpen={isResultModalOpen}
       onClose={() => setIsResultModalOpen(false)}
     />


   </>
  );
}

function CasinoResultModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      id="dtl-result-modal-outer"
      style={{ position: "fixed", inset: 0, zIndex: 1040 }}
      onClick={onClose}
    >
      <div
        id="dtl-result-modal"
        role="dialog"
        aria-labelledby="dtl-result-modal-title"
        aria-describedby="dtl-result-modal-body"
        className="modal fade show casino-result"
        aria-modal="true"
        style={{ display: "block" }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-dialog modal-xl">
          <span tabIndex={0} />
          <div tabIndex={-1} className="modal-content">
            <header className="modal-header">
              <h5 id="dtl-result-modal-title" className="modal-title">
                V-20-20 D T L Result
              </h5>
              <button type="button" aria-label="Close" className="close" onClick={onClose}>
                ×
              </button>
            </header>
            <div id="dtl-result-modal-body" className="modal-body">
              <div>
                <div className="casino-result-round">
                  <div>Round-ID: 319260921232748</div>
                  <div>
                    Match Time: <span>21/09/2026 23:27:48</span>
                  </div>
                </div>
                <div className="row row5 dtl20-result text-center">
                  <ResultCard
                    name="Dragon"
                    card="9SS"
                    winner
                  />
                  <ResultCard name="Tiger" card="6DD" />
                  <ResultCard name="Lion" card="2HH" />
                  <div className="col-12 col-lg-6">
                    <div className="casino-result-desc">
                      <div className="casino-result-desc-item">
                        <div>Winner</div><div>Dragon</div>
                      </div>
                      <div className="casino-result-desc-item">
                        <div>Red/Black</div><div>D : Black | T : Red | L : Red</div>
                      </div>
                      <div className="casino-result-desc-item">
                        <div>Odd/Even</div><div>D : Odd | T : Even | L : Even</div>
                      </div>
                      <div className="casino-result-desc-item">
                        <div>Card</div><div>D : 9 | T : 6 | L : 2</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span tabIndex={0} />
        </div>
      </div>
      <div className="modal-backdrop show" aria-hidden="true" />
    </div>
  );
}

function CasinoRules({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      id="casino-vieo-rules"
      role="dialog"
      aria-modal="true"
      aria-label="V-20-20 DTL rules"
      className="casino-vieo-rules show d-none-small show-rules"
      style={{ display: "block" }}
    >
      <div className="rules-header">
        <div>Rules</div>
        <i className="fas fa-times" role="button" tabIndex={0} aria-label="Close rules" onClick={onClose} onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") onClose();
        }} />
      </div>
      <div className="rules-body">
        <style>{`
          .rules-section .row.row5 { margin-left: -5px; margin-right: -5px; }
          .rules-section .pl-2 { padding-left: .5rem !important; }
          .rules-section .pr-2 { padding-right: .5rem !important; }
          .rules-section .row.row5 > [class*="col-"], .rules-section .row.row5 > [class*="col"] { padding-left: 5px; padding-right: 5px; }
          .rules-section { text-align: left; margin-bottom: 10px; }
          .rules-section .table { color: #fff; border: 1px solid #444; background-color: #222; font-size: 12px; }
          .rules-section .table td, .rules-section .table th { border-bottom: 1px solid #444; }
          .rules-section ul li, .rules-section p { margin-bottom: 5px; }
          .rules-section::-webkit-scrollbar { width: 8px; }
          .rules-section::-webkit-scrollbar-track { background: #666666; }
          .rules-section::-webkit-scrollbar-thumb { background-color: #333333; }
          .rules-section .rules-highlight { color: #FDCF13; font-size: 16px; }
          .rules-section .rules-sub-highlight { color: #FDCF13; font-size: 14px; }
          .rules-section .list-style, .rules-section .list-style li { list-style: disc; }
          .rules-section .rule-card { height: 20px; margin-left: 5px; }
          .rules-section .card-character { font-family: Card Characters; }
          .rules-section .red-card { color: red; }
          .rules-section .black-card { color: black; }
          .rules-section .cards-box { background: #fff; padding: 6px; display: inline-block; color: #000; min-width: 150px; }
        `}</style>
        <div className="rules-section">
          <ul className="pl-4 pr-4 list-style">
            <li>20-20 DTL(Dragon Tiger Lion) is a 52 playing cards game, In DTL game 3 hands are dealt: for each 3 player. The player will bets which will win.</li>
            <li>The ranking of cards is, from lowest to highest: Ace, 2, 3, 4, 5, 6, 7,8, 9, 10, Jack, Queen and King when Ace is “1” and King is “13”.</li>
            <li>
              On same card with different suit, Winner will be declare based on below winning suit sequence.
              <p />
              <div className="cards-box"><span className="card-character black-card ml-1">1{"}"}</span> <span>1st</span></div>
              <p />
              <div className="cards-box"><span className="card-character red-card ml-1">1{"{"}</span> <span>2nd</span></div>
              <p />
              <div className="cards-box"><span className="card-character black-card ml-1">1]</span> <span>3rd</span></div>
              <p />
              <div className="cards-box"><span className="card-character red-card ml-1">1[</span> <span>4th</span></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function ResultCard({ name, card, winner = false }) {
  const assetBase = "https://versionobj.ecoassetsservice.com/v106/static/admin/img";

  return (
    <div className="col-12 col-lg-2">
      <div className="casino-result-cards">
        {winner && (
          <div className="casino-result-cards-item">
            <img src={`${assetBase}/winner.png`} className="winner-icon" alt="Winner" />
          </div>
        )}
        <div className="d-inline-block">
          <h4>{name}</h4>
          <div className="casino-result-cards-item">
            <img src={`${assetBase}/cards/${card}.png`} alt={`${name} card`} />
          </div>
        </div>
      </div>
    </div>
  );
}
